<div v-if="inline">
  <div class="card-body">
    <div v-for="(speaker, index) in speakers"
         :key="index"
         class="border rounded-5 p-2 mb-3 bg-light position-relative">
      <button
        class="btn btn-sm position-absolute top-0 end-0 m-3 rounded-circle"
        type="button"
        @click="speaker._is_existing && speaker.id ? delete_speaker(speaker.id) : remove_speaker(index)"
      >
        <i class="bi bi-x-lg fs-6"></i>
      </button>

      <p class="text-primary fw-bold small">SPEAKER {{ index + 1 }}</p>
      <div class="row">
        <div class="col-md-3 text-center">
          <div class="border border-danger border-2 rounded-circle d-flex align-items-center justify-content-center mx-auto profile-preview-img pointer"
              @click="$refs['photo'+index][0].click()">
            <img v-if="speaker.photoPreviewUrl"
                :src="speaker.photoPreviewUrl"
                class="w-100 h-100 object-fit-cover" />
            <i v-else class="bx bx-user fs-1 text-secondary"></i>
          </div>
          <input type="file"
                class="d-none"
                :ref="'photo'+index"
                accept="image/*"
                @change="handle_photo_upload($event, index)" />
          <small class="text-danger d-block mt-2 text-xxs cursor-pointer"
                @click="$refs['photo'+index][0].click()">
            {{ speaker.photoPreviewUrl ? 'Change photo' : 'Upload photo' }}
          </small>
        </div>
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label text-xxs fw-500">First Name</label><span class="text-danger">*</span>
              <input type="text"
                    v-model="speaker.first_name"
                    class="form-control rounded text-xxs"
                    placeholder="e.g. Jane">
              <p v-if="speakers_errors['speaker_first_name' + index]" class="text-danger text-xxs">{{ speakers_errors['speaker_first_name' + index] }}</p>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label text-xxs fw-500">Last Name</label><span class="text-danger">*</span>
              <input type="text"
                    v-model="speaker.last_name"
                    class="form-control rounded text-xxs"
                    placeholder="e.g. Doe">
              <p v-if="speakers_errors['speaker_last_name' + index]" class="text-danger text-xxs">{{ speakers_errors['speaker_last_name' + index] }}</p>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label text-xxs fw-500">Short Bio</label>
            <textarea rows="3"
                      maxlength="300"
                      v-model="speaker.short_bio"
                      class="form-control rounded text-xxs"
                      placeholder="A brief introduction shown on the event page..."></textarea>

            <div class="text-end small text-muted text-xxs">
              {{ speaker.short_bio.length }}/300
            </div>
          </div>

          <div>
            <label class="form-label text-xxs fw-500 me-4">Social Links</label>

            <div v-for="(link, linkIndex) in speaker.social_links"
                :key="linkIndex"
                class="row align-items-center mt-2">

              <div class="col-md-4">
                <select class="form-select rounded-3 text-xxs" v-model="link.platform">
                  <option v-for="option in social_platforms" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <input type="text"
                      v-model="link.url"
                      class="form-control rounded-3"
                      placeholder="Enter profile link">
              </div>

              <div class="col-md-2 text-end">
                <button class="btn btn-link text-danger text-xxs"
                        type="button"
                        @click="remove_social_link(index, linkIndex)">
                  <i class="bx bx-trash fs-6"></i>
                </button>
              </div>
            </div>
            <button class="btn btn-primary rounded btn-sm mt-2 text-xxs"
                    type="button"
                    @click="add_social_link(index)">
              Add Social Link
            </button>
          </div>

        </div>
      </div>
    </div>

    <button class="btn btn-primary rounded text-xxs py-2"
            type="button"
            @click="add_speaker_button">
      Add Speaker
    </button>

    <div class="d-flex justify-content-end mt-3">
      <button class="btn btn-primary btn-sm text-xxs me-2"
              type="button"
              @click="save_speakers">
        Save
      </button>
    </div>
  </div>
</div>

<!--Edit  Speaker Modal-->
<teleport to="body">
  <div class="modal fade" id="edit_speaker_modal" tabindex="-1" aria-labelledby="editSpeakerModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content rounded shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-white" id="editSpeakerModalLabel">Edit Speaker</h5>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body table-responsive" v-if="selected_event_speaker">
          <div class="modal-body">

            <div class="border rounded-5 p-3 mb-3 bg-light position-relative">
              <div class="row">
                <div class="col-md-3 text-center">
                  <div class="border border-danger border-2 rounded-circle d-flex align-items-center justify-content-center mx-auto profile-preview-img pointer"
                      @click="$refs.editPhotoInput.click()">
                    <img v-if="editPhotoPreviewUrl || (selected_event_speaker?.speaker_files && selected_event_speaker.speaker_files.length > 0)"
                        :src="editPhotoPreviewUrl || selected_event_speaker?.speaker_files[0].file.file_url"
                        class="w-100 h-100 object-fit-cover" />
                    <i v-else class="bx bx-user fs-1 text-secondary"></i>
                  </div>

                  <input type="file"
                        class="d-none"
                        ref="editPhotoInput"
                        accept="image/*"
                        @change="handle_edit_photo_upload($event)" />

                  <small class="text-danger d-block mt-2 text-xxs pointer"
                        @click="$refs.editPhotoInput.click()">
                    {{ editPhotoPreviewUrl || (selected_event_speaker?.speaker_files && selected_event_speaker.speaker_files.length > 0) ? 'Change photo' : 'Upload photo' }}
                  </small>
                </div>

                <div class="col-md-9">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label class="form-label text-xxs fw-500">First Name</label><span
                  class="text-danger">*</span>
                      <input type="text" v-model="selected_event_speaker.first_name" class="form-control rounded text-xxs">
                      <p v-if="speakers_errors['speaker_first_name']" class="text-danger text-xxs">{{ speakers_errors['speaker_first_name'] }}</p>

                    </div>

                    <div class="col-md-6 mb-3">
                      <label class="form-label text-xxs fw-500">Last Name</label><span
                  class="text-danger">*</span>
                      <input type="text" v-model="selected_event_speaker.last_name" class="form-control rounded text-xxs">
                      <p v-if="speakers_errors['speaker_last_name' + index]" class="text-danger text-xxs">{{ speakers_errors['speaker_last_name' + index] }}</p>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label class="form-label text-xxs fw-500">Bio</label>
                    <textarea rows="3" maxlength="300" v-model="selected_event_speaker.bio" class="form-control rounded text-xxs"></textarea>
                    <div class="text-end small text-muted text-xxs">
                      {{ selected_event_speaker.bio?.length || 0 }}/300
                    </div>
                  </div>

                  <div>
                    <label class="form-label text-xxs fw-500 me-4">Social Links</label>

                    <div v-for="(link, linkIndex) in selected_event_speaker.social_urls" :key="linkIndex" class="row align-items-center mt-2">
                      <div class="col-md-4">
                        <select class="form-select rounded-3 text-xxs" v-model="link.social_type.name">
                          <option v-for="option in social_platforms" :key="option.value" :value="option.value">
                            {{ option.label }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <input type="text" v-model="link.social_url" class="form-control rounded-3" placeholder="Enter profile link">
                      </div>
                      <div class="col-md-2 text-end">
                        <button class="btn btn-link text-danger text-xxs" @click="remove_edit_social_link(linkIndex)">
                          <i class="bx bx-trash fs-6"></i>
                        </button>
                      </div>
                    </div>

                    <button class="btn btn-outline-primary btn-sm mt-3 text-xxs" @click="add_edit_social_link">
                      Add Social Link
                    </button>

                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="modal-footer border-0">
            <button class="btn btn-primary btn-sm text-xxs" @click="update_speaker">Update Details</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<!-- Add Speakers Modal -->
<teleport to="body">
  <div class="modal fade" id="add_speakers_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content rounded shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-white" id="exampleModalLabel">Add Speakers</h5>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close" @click="preview_document_url=``"></button>
        </div>
        <div class="modal-body table-responsive">
      <!-- BODY -->
      <div class="modal-body">
        <!-- SPEAKER CARD -->
        <div v-for="(speaker, index) in speakers"
             :key="index"
             class="border rounded-5 p-2 mb-3 bg-light position-relative">
          <!-- Remove Speaker -->
          <button class="btn btn-sm btn-outline-danger position-absolute top-0 end-0 m-3 rounded-circle"
                  @click="remove_speaker(index)">
            ✕
          </button>

          <p class="text-primary fw-bold small">SPEAKER {{ index + 1 }}</p>
          <div class="row">
            <div class="col-md-3 text-center">
              <div class="border border-danger border-2 rounded-circle d-flex align-items-center justify-content-center mx-auto profile-preview-img pointer"
                  @click="$refs['photo'+index][0].click()">
                <img v-if="speaker.photo"
                    :src="speaker.photoPreviewUrl"
                    class="w-100 h-100 object-fit-cover" />
                <i v-else class="bx bx-user fs-1 text-secondary"></i>
              </div>
              <input type="file"
                    class="d-none"
                    :ref="'photo'+index"
                    accept="image/*"
                    @change="handle_photo_upload($event, index)" />
              <small class="text-danger d-block mt-2 text-xxs cursor-pointer"
                    @click="$refs['photo'+index][0].click()">
                {{ speaker.photoPreviewUrl ? 'Change photo' : 'Upload photo' }}
              </small>
            </div>
            <div class="col-md-9">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label text-xxs fw-500">First Name</label><span
                  class="text-danger">*</span>
                  <input type="text"
                         v-model="speaker.first_name"
                         class="form-control rounded text-xxs"
                         placeholder="e.g. Jane">
                  <p v-if="speakers_errors['speaker_first_name' + index]" class="text-danger text-xxs">{{ speakers_errors['speaker_first_name' + index] }}</p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label text-xxs fw-500">Last Name</label><span
                  class="text-danger">*</span>
                  <input type="text"
                         v-model="speaker.last_name"
                         class="form-control rounded text-xxs"
                         placeholder="e.g. Doe">
                  <p v-if="speakers_errors['speaker_last_name' + index]" class="text-danger text-xxs">{{ speakers_errors['speaker_last_name' + index] }}</p>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label text-xxs fw-500">Short Bio</label>
                <textarea rows="3"
                          maxlength="300"
                          v-model="speaker.short_bio"
                          class="form-control rounded text-xxs"
                          placeholder="A brief introduction shown on the event page..."></textarea>

                <div class="text-end small text-muted text-xxs">
                  {{ speaker.short_bio.length }}/300
                </div>
              </div>

              <div>
                <label class="form-label text-xxs fw-500 me-4">Social Links</label>

                <div v-for="(link, linkIndex) in speaker.social_links"
                     :key="linkIndex"
                     class="row align-items-center mt-2">

                  <div class="col-md-4">
                    <select class="form-select rounded-3 text-xxs" v-model="link.platform">
                      <option v-for="option in social_platforms" :key="option.value" :value="option.value">
                        {{ option.label }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-6">
                    <input type="text"
                           v-model="link.url"
                           class="form-control rounded-3"
                           placeholder="Enter profile link">
                  </div>

                  <div class="col-md-2 text-end">
                    <button class="btn btn-link text-danger text-xxs"
                            @click="remove_social_link(index, linkIndex)">
                      <i class="bx bx-trash fs-6"></i>
                    </button>
                  </div>
                </div>
                <button class="btn btn-outline-danger btn-sm mt-2 text-xxs"
                        @click="add_social_link(index)">
                  Add Social Link
                </button>
              </div>

            </div>
          </div>
        </div>
        <!-- ADD SPEAKER BUTTON -->
        <button class="btn btn-outline-danger w-100 rounded-5 text-xxs py-2"
                @click="add_speaker_button">
          Add Speaker
        </button>
      </div>
      <!-- FOOTER -->
      <div class="modal-footer border-0">
        <button class="btn btn-primary btn-sm text-xxs me-2"
                @click="save_speakers">
          Save
        </button>
      </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<!-- modal to view Speakers -->
<teleport to="body">
  <div class="modal fade" id="event_speakers_modal" tabindex="-1" aria-labelledby="eventSpeakersModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-white" id="exampleModalLabel">View Event Speakers</h5>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close" @click="preview_document_url=``"></button>
        </div>
        <div class="modal-body bg-light px-4 pb-4">
          <div v-if="selected_event_agenda?.speakers?.length > 0" class="row g-3">
            <div
              class="col-12 col-sm-6 col-md-4"
              v-for="speaker in selected_event_agenda?.speakers"
              :key="speaker.id"
            >
              <div class="card h-100 text-center border-0 shadow-sm speaker-card position-relative rounded-4 transition-all">
                <div class="position-absolute top-0 end-0 p-2 d-flex gap-1">
                  <button v-if="token_exists && String(selected_event_agenda?.user?.id) === String(get_user_id()) || token_exists && user_details.user_role === 'admin'"
                        class="btn btn-sm btn-light border-0 text-primary rounded-circle action-btn shadow-none" @click="edit_speaker(speaker)" title="Edit">
                    <i class='bx bx-edit'></i>
                  </button>
                  <button v-if="token_exists && String(selected_event_agenda?.user?.id) === String(get_user_id()) || token_exists && user_details.user_role === 'admin'"
                          class="btn btn-sm btn-light border-0 text-danger rounded-circle action-btn shadow-none" @click="delete_speaker(speaker.id)" title="Delete">
                    <i class='bx bx-trash'></i>
                  </button>
                </div>
                <div class="card-body d-flex flex-column align-items-center p-4">
                  <div class="circular-progress-container rounded-circle d-flex align-items-center justify-content-center mb-3">
                    <img
                      v-if="speaker.speaker_files && speaker.speaker_files.length > 0"
                      :src="speaker?.speaker_files[0]?.file?.file_url"
                      class="rounded-circle w-100 h-100 object-fit-cover"
                    >
                    <div v-else class="text-dark-purple fs-2">
                      <i class="bx bxs-user"></i>
                    </div>
                  </div>
                  <h6 class="fw-bold text-dark mb-1 fs-6">
                    {{ speaker.first_name }} {{ speaker.last_name }}
                  </h6>
                  <span class="text-muted text-xs mb-1 text-truncate w-100 px-2">
                    {{ speaker.bio}}
                  </span>
                  <div v-if="speaker.social_urls && speaker.social_urls.length > 0" class="d-flex justify-content-center flex-wrap gap-3 mt-3 w-100">
                    <a
                      v-for="(link, index) in speaker.social_urls"
                      :key="index"
                      :href="link.social_url"
                      target="_blank"
                      class="text-decoration-none direct-social-icon"
                      :title="link.social_type?.name"
                    >
                      <i :class="[
                        'bi fs-5', 
                        {
                          'instagram': 'bi-instagram text-danger',
                          'facebook': 'bi-facebook text-primary',
                          'linkedin': 'bi-linkedin text-info',
                          'x_twitter': 'bi-twitter-x text-dark',
                          'youtube': 'bi-youtube text-danger',
                          'tiktok': 'bi-tiktok text-dark',
                          'website': 'bi-globe text-secondary'
                        }[link.social_type?.name?.toLowerCase()] || 'bi-link text-muted'
                      ]"></i>
                    </a>
                </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</teleport>

